import React, { useState } from 'react';
import { Plus, Edit, Trash2, Award } from 'lucide-react';

const GradingSystem = () => {
  const [grades, setGrades] = useState([
    { id: 1, grade: 'A+', min_marks: 90, max_marks: 100, grade_point: 4.0, description: 'Outstanding' },
    { id: 2, grade: 'A', min_marks: 80, max_marks: 89, grade_point: 3.5, description: 'Excellent' },
    { id: 3, grade: 'B+', min_marks: 70, max_marks: 79, grade_point: 3.0, description: 'Very Good' },
    { id: 4, grade: 'B', min_marks: 60, max_marks: 69, grade_point: 2.5, description: 'Good' },
    { id: 5, grade: 'C', min_marks: 50, max_marks: 59, grade_point: 2.0, description: 'Average' },
    { id: 6, grade: 'D', min_marks: 40, max_marks: 49, grade_point: 1.0, description: 'Pass' },
    { id: 7, grade: 'F', min_marks: 0, max_marks: 39, grade_point: 0.0, description: 'Fail' }
  ]);
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Grading System</h1>
          <p className="text-sm text-gray-500 mt-1">Configure grading scale and criteria</p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          <Plus className="h-4 w-4" />
          Add Grade
        </button>
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
        <p className="text-sm text-blue-700">
          This grading system will be applied to all exams. Changes will affect future grade calculations.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Grade</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Min Marks</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Max Marks</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Grade Point</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {grades.map((grade) => (
              <tr key={grade.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <Award className="h-4 w-4 text-blue-600" />
                    <span className="text-lg font-bold text-gray-900">{grade.grade}</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-900">{grade.min_marks}</td>
                <td className="px-6 py-4 text-center text-sm text-gray-900">{grade.max_marks}</td>
                <td className="px-6 py-4 text-center text-sm font-medium text-blue-600">{grade.grade_point}</td>
                <td className="px-6 py-4 text-sm text-gray-500">{grade.description}</td>
                <td className="px-6 py-4 text-right">
                  <div className="flex justify-end gap-2">
                    <button className="text-blue-600 hover:text-blue-900"><Edit className="h-4 w-4" /></button>
                    <button className="text-red-600 hover:text-red-900"><Trash2 className="h-4 w-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GradingSystem;